import { render, staticRenderFns } from "./courrier.vue?vue&type=template&id=4cfe6d72"
import script from "./courrier.vue?vue&type=script&lang=js"
export * from "./courrier.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports